
<h5 class="text-center">Posjetite nas i na:</h5>
<div class="container social d-flex justify-content-around">
  <a href="" target="_blank"><i class="fab fa-facebook pl-5 pr-5 pt-3 fa-3x"></i></a>
  <a href="" target="_blank"><i class="fab fa-instagram  pl-5 pr-5 pt-3 fa-3x"></i></a>
  <a href="" target="_blank"><i class="fab fa-twitter-square  pl-5 pr-5 pt-3 fa-3x"></i></a>
</div>
<h4 class="text-center">Dizajnirao: Amar Alibegović <br/>2020. godina</h4>
